<template>
    <div>
        <div class="panel">
            <div class="panel__header">
                <h2>
                    <i class="panel__header__icon icons icon-user"></i>
                    <span>{{$t('dashboard.profile.title')}}</span>
                </h2>
                <!-- <div @click.prevent="editProfile" class="panel_header__action">
                    <i class="panel_header__action__icon icons icon-plus"></i>
                    <a class="button--link">{{$t('common.edit')}}</a>
                </div> -->
            </div>
            <div class="panel__body">
                <client-form :client="client" />
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Prop } from 'vue-property-decorator';

    import Client from '@/models/Client';
    import ClientForm from '@/components/forms/dashboard/ClientForm';

    @Component({
        components: {
            ClientForm
        }
    })
    export default class ProfilePanel extends Vue {
        name = 'profile-panel-dashboard';
        client = new Client();

        created() {
            this.client.fill(this.$store.state.trajectory.trajectory.client);
        }
    }

    Vue.component('profile-panel-dashboard', ProfilePanel);
</script>



// WEBPACK FOOTER //
// src/components/panels/dashboard/ProfilePanel.vue